import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { daysSince } from '../../utils/Utils.js';
import { formatDate as formatDateLocale } from '../../../utils/dateFormat.js';
import './LotCardList.css';

const formatLotId = (lotId, prefix) => {
  if (!lotId && lotId !== 0) return '—';
  return `${prefix}-${String(lotId).padStart(4, '0')}`;
};

const formatDate = (dateString) => {
  if (!dateString) return '—';
  const dateStr = dateString.length === 10 ? dateString + 'T12:00:00' : dateString;
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateString;
  return formatDateLocale(date);
};

const LotCard = ({ row, animalCounts, assignmentsByLotId = {} }) => {
  const { t }        = useTranslation();
  const navigate     = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const count = animalCounts[row.lot_id] || 0;
  // start_date lives on the lot's active assignment now, not cached on the
  // lot doc — see protocol_assignments.Assign.
  const startDate = assignmentsByLotId[row.lot_id]?.start_date;
  const day = daysSince(startDate);

  return (
    <div className={`lot-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="lot-card-main">
        <div className="lot-card-id">{formatLotId(row.lot_id, t('lot_prefix'))}</div>
        <div className="lot-card-count">{count} {t('animals_count_short') || 'animals'}</div>
        <div className="lot-card-chevron">{expanded ? '▲' : '▼'}</div>
        <div className="lot-card-secondary">
          {row.name && <span>{row.name}</span>}
          <span>{row.protocol_name || '—'}</span>
          <span>{t('day')} {day}</span>
        </div>
      </div>

      {expanded && (
        <div className="lot-card-detail" onClick={e => e.stopPropagation()}>
          <div className="lot-card-detail-row">
            <span>{t('start_date')}</span><span>{formatDate(startDate)}</span>
          </div>
          <div className="lot-card-detail-row">
            <span>{t('bull')}</span><span>{row.bull_name || '—'}</span>
          </div>
          <div className="lot-card-detail-row">
            <span>{t('created_by')}</span><span>{row.created_by || '—'}</span>
          </div>
          <div className="lot-card-actions">
            <button
              className="lot-card-view-btn"
              onClick={() => navigate(`/reproduction/lots/${row.lot_id}`)}
            >
              {t('view_lot') || 'View Lot'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const LotCardList = ({ data, onRefresh, animalCounts = {}, assignmentsByLotId = {} }) => {
  return (
    <div className="lot-card-list">
      {data && data.map(row => (
        <LotCard
          key={row._id}
          row={row}
          animalCounts={animalCounts}
          assignmentsByLotId={assignmentsByLotId}
        />
      ))}
      {(!data || data.length === 0) && (
        <div className="lot-card-empty">—</div>
      )}
    </div>
  );
};

export default LotCardList;
